<template>
<div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base practiceItem">
  <vx-card class="text-center" :class="{progress : progress}" style="height:180px;" v-if="subjectInfo" scrollHeight>
    <div class="text-center">
      <div class="vx-row">
        <div style="display: flex; align-items: center; width: 100%; justify-content: space-between;">
          <div class="state" style="margin-left: 30px;">
            <button type="button" name="button" :class="{isActive : item.isActive}" v-for="(item, index) in button_state" :key="index" @click="changeState(item)">{{ item.state }}</button>
            <button v-if="superAdminState == true" type="button" name="button" :class="{isActive : pay_state.isActive}" @click="changeState(pay_state)">지급</button>
          </div>
          <span v-if="subjectInfo.type_state >= 1" style="margin-right: 30px;">{{ userID() }}</span>
        </div>
      </div>
      <div style="font-size: 15px; display: flex; justify-content: space-around; color: rgb(29,156,211); margin: 20px 0 10px 0;">
        <strong v-if="subjectInfo.info == 'sat'">3학년</strong>
        <strong v-else>{{subjectInfo.grade}}학년</strong>
        <strong>{{subjectInfo.subject}}</strong>
        <strong>{{subjectInfo.test_name}}</strong>
      </div>
    </div>
    <div>
      <vs-divider style="margin-top:2px;"/>
      <div class="flex justify-center flex-wrap" style="margin-top:10px;">
        <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-list" @click="showSubject()"></vs-button>
      </div>
    </div>
  </vx-card>

  <vs-popup background-color="rgba(0,0,0,.6)" title="warning!" button-close-hidden :active.sync="selectPopup">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <p style="font-size: 16px;">문제유형 선택이 완료되지 않았습니다.</p>
      <vs-button @click="moveToSelect" style="padding: 10px;">문제로 이동하기</vs-button>
    </div>
  </vs-popup>
  <vs-popup background-color="rgba(0,0,0,.6)" title="warning!" button-close-hidden :active.sync="alreadyRun">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <p style="font-size: 16px;">이미 진행중인 시험셋입니다. 다른 시험을 선택 해주세요.</p>
      <vs-button @click="close" style="padding: 10px;">확인</vs-button>
    </div>
  </vs-popup>
</div>
</template>


<script>

export default {
  props: ['subjectInfo', 'type', 'selectedId'],
  data() {
    return {
      superAdminState : this.$acl.check('superAdmin'),
      serviceVal: false,
      data_local: '',
      testVal: false,
      button_state: [
        {id: 0, state: '대기', isActive: false},
        {id: 1, state: '진행', isActive: false},
        {id: 2, state: '완료', isActive: false}
      ],
      pay_state: {id: 3, state: '지급', isActive: false},
      selectFlag: true,
      selectId: 0,
      selectPopup: false,
      progress: false,
      progressId: null,
      alreadyRun: false,
    }
  },
  components: {

  },
  watch: {
    serviceVal() {
      this.data_local.admin_check = this.serviceVal ? 0 : 1
      // this.$store.dispatch('etest/updateAdminExamState', {
      //   'id': this.data_local.id,
      //   'admin_check': this.data_local.admin_check
      // })
    },
    testVal() {
      this.data_local.test_state = this.testVal ? 1 : 0
      // console.log(this.data_local.test_state)
      // if (this.data_local.test_state == 1) {
      //   this.$store.dispatch('etest/updateAdminTestState', {
      //     'id': this.data_local.id,
      //     'test_state': this.data_local.test_state
      //   })
      // }
    },
    getProgressExam() {
      if(this.getProgressExam == this.subjectInfo.id){
        this.progress = true
      }
      else{
        this.progress = false
      }
    },
  },
  created() {
    if(this.subjectInfo.type_state <= 2){
      this.button_state[this.subjectInfo.type_state].isActive = true
    }else {
      this.pay_state.isActive = true
    }
    if(!this.subjectInfo){
      return
    }
    this.data_local = JSON.parse(JSON.stringify(this.subjectInfo))
    this.serviceVal = this.data_local.admin_check == 0 ? true : false
    this.testVal = this.data_local.test_state == 1 ? true : false
  },
  computed: {
    questionList() {
      return this.$store.state.etest.questionList
    },
    categoryList() {
      return this.$store.state.etest.categoryList
    },
    mainCategoryList() {
      return this.$store.state.etest.mainCategoryList
    },
    subCategoryList() {
      return this.$store.state.etest.subCategoryList
    },
    getProgressExam() {
      return this.$store.state.etest.progressExam
    },
    activeUser() {
      return this.$store.state.AppActiveUser
    },
    examRunState() {
      return this.$store.state.etest.examRunState
    }
  },
  methods: {
    userID() {
      return 'ID : ' + this.subjectInfo.teacher_id
    },
    close() {
      this.alreadyRun = false
      this.$store.dispatch('etest/getEpracticeExam', this.selectedId)
    },
    moveToSelect() {
      this.$store.commit('etest/ACTIVE_SUBJECT', this.subjectInfo)
      this.$store.commit('etest/ACTIVE_QUESTION', {
        id: -1
      })
      this.$store.dispatch('etest/getEtestQuestion', this.subjectInfo.id).then(() => {
        if (this.questionList.length) {
          this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[this.selectId])
        }
        this.$router.push('/app/practice/form')
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    selectFilter_1(val) {
      return this.mainCategoryList.filter(item => item.category_id == val)
    },
    selectFilter_2(val) {
      return this.subCategoryList.filter(item => item.main_category_id == val)
    },
    showSubject() {
      localStorage.setItem(this.progressId, this.subjectInfo.id)
      this.$store.commit('etest/SET_PROGRESS_EXAM', localStorage.getItem(this.progressId))

      this.$store.commit('etest/ACTIVE_SUBJECT', this.subjectInfo)
      this.$store.commit('etest/ACTIVE_QUESTION', {
        id: -1
      })
      this.$store.dispatch('etest/getEtestQuestion', this.subjectInfo.id).then(() => {
        if (this.questionList.length) {
          this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[0])
        }
        this.$router.push('/app/practice/form')
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    updatePracticeState(val) {
      this.$store.dispatch('etest/updatePracticeState', {
          id: this.subjectInfo.id,
          type_state: val.id
        })
        .then(() => {
          if(val.id == 1){
            this.$store.commit('etest/UPDATE_TEACHER_ID', {
              exam_id: this.subjectInfo.exam_id,
              teacher_id: this.activeUser.uid
            })
          }
          this.$vs.notify({
            color: 'success',
            title: '수정 완료',
          })
        }).catch(() => {
          if(val.id == 1){
            this.alreadyRun = true
          }
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    changeState(val) {
      localStorage.setItem(this.progressId, this.subjectInfo.id)
      this.$store.commit('etest/SET_PROGRESS_EXAM', localStorage.getItem(this.progressId))
      if(val.id != 2){
        for(var i in this.button_state){
          this.button_state[i].isActive = false
        }
        this.pay_state.isActive = false
        val.isActive = true
        this.updatePracticeState(val)
      }else if(val.id == 2){
        this.$vs.loading()
        this.$store.commit('etest/ACTIVE_SUBJECT', this.subjectInfo)
        this.$store.commit('etest/ACTIVE_QUESTION', {
          id: -1
        })
        this.$store.dispatch('etest/getEtestQuestion', this.subjectInfo.id).then(() => {
          for(var i in this.questionList){
            if(!this.questionList[i].category_id){
              this.selectId = i
              this.selectFlag = false
              break
            }
            if(!this.questionList[i].main_category_id && this.selectFilter_1(this.questionList[i].category_id).length != 0){
              this.selectId = i
              this.selectFlag = false
              break
            }
            if(!this.questionList[i].sub_category_id && this.selectFilter_2(this.questionList[i].main_category_id).length != 0){
              this.selectId = i
              this.selectFlag = false
              break
            }
          }
          this.$vs.loading.close()
          if(this.selectFlag){
            val.isActive = true
            this.button_state[0].isActive = false
            this.button_state[1].isActive = false
            this.pay_state.isActive = false
            this.updatePracticeState(val)
          }else{
            this.selectPopup = true
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
      }
    },
  },
  mounted() {
    if(this.getProgressExam == this.subjectInfo.id){
      this.progress = true
    }
  },
}
</script>

<style>
.text {
  font-size: 14px;
  max-width: 400px;
  line-height: 1.5;
}
.practiceItem .progress{
  background-color: #ddd;
}
.practiceItem .state button{
  background-color: #fff;
  outline: none;
  color: #333;
  border: 1px solid #ddd;
  padding: 7px 10px;
  font-weight: bold;
  transition: 0.3s;
  cursor: pointer;
  border-left: none;
}
.practiceItem .state button:hover{
  background-color: #F9EFC9;
}
.practiceItem .state button:nth-child(1){
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  border-left: 1px solid #ddd;
}
.practiceItem .state button:nth-child(2){
  /* border-right: none; */
}
.practiceItem .state button:last-child{
  border-top-right-radius: 15px;
  /* border-left: none; */
  border-bottom-right-radius: 15px;
}
.practiceItem .state button.isActive{
  background-color: #ffe998;
}
</style>
